import { MapLayer } from './mapLayer.abstract';

// currently abstract but could be real
export abstract class ImageOverlayLayer extends MapLayer {

  constructor(id: string, name?: string) {
    super(id, name);
    // Default options
    this.options.setOptions({
      pane: 'overlayPane',
    });

    // this.options.zIndex.watch().subscribe((value: number) => {
    //   if (this.leafletMapLayer != null) {
    //     console.debug('this.leafletMapLayer', this.leafletMapLayer);
    //     this.leafletMapLayer['setZIndex'](value);
    //   }
    // });
  }

}
